/* Material */
import Alert from '@mui/material/Alert'
import useStyles from '../styles'

/* Material-Icons */
//import LocalShippingIcon from '@mui/icons-material/LocalShipping'

/* Components */
import NoBr from 'src/components/js_elements/NoBr'

/* Config */
import config from 'src/config'
import { useProductInquiryConfig } from 'src/context/ProductInquiryContext'

const { stockDeliveryTime } = config

interface Props {
  deliverytime?: number
  stockDeliverytime?: number
  inquiredQty: number
  stockQty?: number
  onlyStock?: true
  inquireOnly?: boolean
}

const DeliverytimeDisplay: React.FC<Props> = ({
  deliverytime,
  stockDeliverytime,
  inquiredQty,
  stockQty = 0,
  onlyStock,
  inquireOnly,
}) => {
  const classes = useStyles()
  const productInquiry = useProductInquiryConfig()
  const resolvedStockDeliverytime = stockDeliverytime ?? stockDeliveryTime

  if (inquireOnly) {
    return <Alert severity='info' className={classes.deliverytimeDisplay}>
      {productInquiry.detailNotice}
    </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel nur noch Lagerware */
  if (onlyStock) {
    if (stockQty <= 0) {
      return <Alert
        severity='error'
        className={classes.deliverytimeDisplay}
      >
        Aktuell nicht am Lager. <br />
        Nur solange der Vorrat reicht!
      </Alert>
    }

    return <Alert 
      severity={stockQty <= config.onlyStockWarningLimit ? 'error' : 'success'}
      className={classes.deliverytimeDisplay}
    >
      Noch {stockQty} x am Lager <br />
      Nur solange der Vorrat reicht! <br />
      Lieferzeit: {resolvedStockDeliverytime} Werktage *²
    </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel Bestellbar und auf Lager */
  if (stockQty) {
    if (stockQty >= inquiredQty)
      return <Alert severity='success' className={classes.deliverytimeDisplay}>
        <NoBr>{stockQty} x am Lager</NoBr> <br /> 
        <NoBr>Lieferzeit: {resolvedStockDeliverytime} Werktage *²</NoBr>
      </Alert>
    else
      return <Alert severity='warning' className={classes.deliverytimeDisplay}>
        <NoBr>{stockQty} x am Lager, </NoBr>
        <NoBr>Lieferzeit: {resolvedStockDeliverytime} Werktage *²</NoBr>
        <br />
        <NoBr>{inquiredQty - stockQty} x</NoBr> mit Lieferzeit{' '}
        <NoBr>{deliverytime} Werktage *²</NoBr>
      </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Ganz normale Lieferzeit */
  return <Alert severity='info' className={classes.deliverytimeDisplay}>
    Der Artikel befindet sich in Nachproduktion und ist von uns beim Hersteller 
    bestellt worden. 
    <br /> 
    Die Lieferzeit beträgt {' '}
    <NoBr>{deliverytime} Werktage. *²</NoBr>
  </Alert>
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  
}

export default DeliverytimeDisplay
